import { useScreenBreakpoint } from 'consts/breakpoints';
import { Button } from 'ds/components/button';
import Modal from 'ds/components/modal';
import { Text } from 'ds/components/typography';
import { useLocale } from 'locale';
import React from 'react';
import { connect } from 'react-redux';
import { State } from 'store/state';
import { setUnapprovedAgentPopupStatus } from 'store/state/app/actions';
import { unapprovedAgentPopupStatusSelector } from 'store/state/app/selectors';

interface UnapprovedAgentPopupProps {
  isOpen: boolean;
  onSetUnapprovedAgentPopupStatus: (isOpen: boolean) => void;
}

const UnapprovedAgentPopup: React.FC<UnapprovedAgentPopupProps> = ({ isOpen, onSetUnapprovedAgentPopupStatus }) => {
  const isMobile = useScreenBreakpoint() <= 2;
  const { t } = useLocale();

  if (!isOpen) return null;

  return (
    <Modal
      isOpen
      onClose={() => onSetUnapprovedAgentPopupStatus(false)}
      mobileModalPositionBottom
      title={t('unapproved.agent.warning.title')}
      headerStyle={{ whiteSpace: isMobile ? 'nowrap' : undefined }}
      buttons={(
        <Button
          fullWidth
          size="large"
          onClick={() => onSetUnapprovedAgentPopupStatus(false)}
          data-auto="unapproved-agent-upload-listing-warning"
        >
          {t('listingsPage.noCreditsModal.button.confirm')}
        </Button>
      )}
    >
      <Text style={{ textAlign: 'center' }}>
        {t('unapproved.agent.warning.text')}
      </Text>
    </Modal>
  );
};


const mapStateToProps = (state: State) => ({
  isOpen: unapprovedAgentPopupStatusSelector(state),
});

const mapDispatchToProps = {
  onSetUnapprovedAgentPopupStatus: setUnapprovedAgentPopupStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(UnapprovedAgentPopup);
